import $ from 'jquery';
import {
  editorUndo,
  editorRedo,
  editorAddText,
  editorMoveObjectBackward,
  editorMoveObjectForward,
  onCloneObjects,
  onSaveCanvasBtnClick,
  onPrintCanvasBtnClick,
  onShareCanvasBtnClick,
  resetTextRotation,
  toggleObjectShadow,
  toggleObjectEraser,
  adapt,
} from '~core';
// Text header toolbar migrated to floating controls
import { onLinkServizio } from '~core/navbar';
import { initAllSubmenus } from '~core/navbar/submenus';
import { toggleObjectLock, deleteObject, deselectObjects } from '~src/ui';
import { onTextBorderThicknessChange, removeTextBorder } from '~core/borders';
import { onTextBorderChangeColor } from '~src/sidebar/onTextBorderChangeColor';
import { initCropListeners } from '~src/crop';
import { initRemovebgListeners } from '~core/removebg';
import { initImageEnhancementListeners } from '~src/imageEnhancement';
import { initSmileListeners } from '~core/smile';
import { initColorizeListeners } from '~core/colorize';
import { initExpandListeners } from '~core/expand';
import { initResizeListeners } from '~core/resizeImage';
import { initAiEditListeners } from '~core/aiEdit';
import { modifyState } from '~src/state';
import { startCloneStamp } from '~core/cloneStamp';
import { startMagicEraser } from '~core/magicEraser';
import { startChangeClothes } from '~core/changeClothes';
import { startDissolvenza } from '~core/dissolvenza';
import { initMagicWand } from '~core/magicWand';
import { toggleRuler } from '~core/ruler';

export const addEditorMenuClickListeners = () => {
  $('body').on(
    'click',
    '#sidebar-add-text',
    editorAddText.bind(null, 'HEADING', 'Titolo')
  );
  // Removed text header bindings; handled by floating controls
  $('#editor-menu-object-shadow').click(toggleObjectShadow);
  // Text border toggled via floating controls; header binding removed
  $('#editor-menu-object-eraser').click(toggleObjectEraser);
  $('#editor-menu-image-clone-stamp').click(
    startCloneStamp(window.CloneStamp.MODE_PROGRESSIVE)
  );
  // Use event delegation for dynamically rendered AI features
  $('body').on('click', '#editor-menu-image-magic-eraser', startMagicEraser);
  $('body').on(
    'click',
    '#editor-menu-image-change-clothes',
    startChangeClothes
  );
  $('body').on('click', '#editor-menu-image-dissolvenza', startDissolvenza);
  $('#editor-menu-image-smudge-stamp').click(
    startCloneStamp(window.CloneStamp.MODE_SMUDGE)
  );
  $('#editor-menu-elimina').click(deleteObject);
  $('#editor-menu-undo').click(editorUndo);
  $('#editor-menu-redo').click(editorRedo);
  $('#editor-menu-ruler').click(toggleRuler);
  $('#editor-menu-backward').click(editorMoveObjectBackward);
  $('#editor-menu-forward').click(editorMoveObjectForward);
  $('#editor-menu-salva').click(onSaveCanvasBtnClick);
  $('#editor-menu-print').click(onPrintCanvasBtnClick);
  $('#editor-menu-share').click(onShareCanvasBtnClick);
  $('#editor-menu-obj-clone').click(onCloneObjects);
  $('#editor-menu-lock').click(toggleObjectLock);
  $('#editor-menu-obj-reset-rotation').click(resetTextRotation);
  $('#editor-menu-obj-adapt').click(adapt);
  $('#editor-menu-remove-text-border').click(removeTextBorder);
  $('#editor-menu-text-border-color').click(onTextBorderChangeColor);

  // Text border thickness slider and input
  $('body').on(
    'input change',
    '#editor-text-border-thickness-slider, #editor-text-border-thickness-value',
    onTextBorderThicknessChange
  );

  $('body').on('click', '.linkServizio', onLinkServizio);

  $('body').on('focus', 'input', () => {
    modifyState('isFocusingOnInput', true);
  });

  $('body').on('focusout', 'input', () => {
    modifyState('isFocusingOnInput', false);
  });

  const excludedInputs = ['#input-filter-fonts'];
  ['input[type="search"]', 'input[type="text"]', '#qr-form-user-input'].forEach(
    (selector) => {
      $('body').on('keydown', selector, (el) => {
        if (
          excludedInputs.includes(selector) ||
          excludedInputs.includes(`#${el.currentTarget.id}`)
        ) {
          return;
        }
        modifyState('ignoreNextObjectDeselect', true);
        deselectObjects();
      });
    }
  );

  initAllSubmenus();
  initCropListeners();
  initRemovebgListeners();
  initImageEnhancementListeners();
  initSmileListeners();
  initColorizeListeners();
  initExpandListeners();
  initResizeListeners();
  initAiEditListeners();
  initMagicWand();

  $(document).on('contextmenu', '.protected-image', function (e) {
    e.preventDefault();
    return false;
  });
};
